import { CLPQuotePersonInfo } from '@domgen/dgx-fe-basket';

export interface RegistrationApplianceDetails {
  applianceCode: string;
  applianceName: string;
  basketItemId?: string;
  basketQuoteId?: string;
  brandCode: string;
  brandName: string;
  category?: string;
  clientCode: string;
  clientGroupCode: string;
  firstPayment?: number;
  id: string;
  item?: string;
  modelNumber?: string;
  offerReference?: string;
  partsWarranty?: number;
  person?: CLPQuotePersonInfo;
  purchaseDay: number;
  purchaseMonth: number;
  purchasePrice: number;
  purchaseYear: number;
  retailer?: string;
  serialNumber?: string;
  tax?: number;
  warranty: number;
}
